import { _ as _getNative } from './_getNative.mjs';
import { _ as _root } from './_root.mjs';

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

var _Map = Map;

export { _Map as _ };
